import { type ChildProps, graphql } from '@apollo/client/react/hoc';
import { DataTableNaked, Flyup } from '@spoiler-alert/ui-library';
import React from 'react';
import injectSheet, { type Styles } from 'react-jss';
import { type RouteComponentProps, withRouter } from 'react-router-dom';
import type { DataTableNakedType } from '../../components/component-types';
import { getColumnsFromDataTableProfile } from '../../components/data-table';
import { StagedListingSummaryWithSiteQuery } from '../../graphql/queries';
import routePaths from '../../route-paths';

type StagedInventoryFlyupClassNames = 'flyup' | 'inventory__flyup__space';

interface StagedListingSummary {
  _id: string;
  catalogId: string;
}

interface StagedListingSummaryData {
  currentUserQuery: {
    stagedListingSummaryWithSite: StagedListingSummary[];
  };
}

const TypedDataTableNaked = DataTableNaked as DataTableNakedType<StagedListingSummary>;

interface OwnProps {
  classes: Record<StagedInventoryFlyupClassNames, string>;
  user: { site: { dataTableProfiles?: unknown } };
}

type StagedInventoryFlyupProps = ChildProps<OwnProps & RouteComponentProps, StagedListingSummaryData>;

interface StagedInventoryFlyupState {
  summaries: StagedListingSummary[];
}

const styles: Styles<StagedInventoryFlyupClassNames, StagedInventoryFlyupProps> = {
  flyup: {
    display: 'initial',
  },
  inventory__flyup__space: {},
};

class StagedInventoryFlyup extends React.Component<StagedInventoryFlyupProps, StagedInventoryFlyupState> {
  state: StagedInventoryFlyupState = {
    summaries: [],
  };

  content = React.createRef<HTMLDivElement>();

  static getDerivedStateFromProps(nextProps: StagedInventoryFlyupProps): StagedInventoryFlyupState | null {
    const { data } = nextProps;
    if (data && !data.loading && !data.error) {
      return {
        summaries: data.currentUserQuery?.stagedListingSummaryWithSite ?? [],
      };
    }
    return null;
  }

  getColumns() {
    return getColumnsFromDataTableProfile('Inventory Staged Flyup', this.props.user.site.dataTableProfiles);
  }

  handleRowClick = (row: StagedListingSummary) => {
    this.props.history.push(`${routePaths.staging}/${row.catalogId}`);
  };

  render() {
    const { classes } = this.props;
    const { summaries } = this.state;
    return (
      <div className={classes.flyup}>
        <Flyup title={`Distribution List Summary (${summaries.length})`}>
          <TypedDataTableNaked data={summaries} columns={this.getColumns()} onRowClick={this.handleRowClick} />
          <div className={classes.inventory__flyup__space} />
        </Flyup>
      </div>
    );
  }
}

export default withRouter(
  injectSheet(styles)(graphql<OwnProps & RouteComponentProps, StagedListingSummaryData>(StagedListingSummaryWithSiteQuery)(StagedInventoryFlyup)),
);
